<template>
  <div class="flex flex-col items-center justify-center gap-2 w-full rounded h-full pr-3">
    <div
      v-if="hasSearchQuery"
      class="h-full w-full flex items-center justify-center bg-base rounded-t-2"
      :style="{ color: themeVars.primary3 }"
    >
      <div class="flex flex-col gap-2 items-center justify-center max-w-[400px] text-center pb-[50px]">
        <CIcon icon="magnifying-glass" size="36px" />
        <div class="font-size-[20px]">{{ t('canvasUI.browserApp.foldersFilesEmpty.noResults') }}</div>
        <div class="font-size-[14px]">{{ t('canvasUI.browserApp.foldersFilesEmpty.noResultsDetails') }}</div>
      </div>
    </div>

    <div
      v-else-if="appName === 'admin'"
      class="h-full w-full flex items-center justify-center bg-base rounded-t-2"
      :style="{ color: themeVars.primary3 }"
    >
      <div class="flex flex-col gap-2 items-center justify-center max-w-[400px] text-center pb-[50px]">
        <CIcon icon="file-circle-plus" size="36px" />
        <div class="font-size-[20px]">
          {{ t('canvasUI.browserApp.foldersFilesEmpty.description') }}
        </div>
        <div class="font-size-[14px]">
          {{ t('canvasUI.browserApp.foldersFilesEmpty.descriptionDetails') }}
        </div>
      </div>
    </div>

    <div
      v-else
      class="h-full w-full flex items-center justify-center bg-base rounded-t-2"
      :style="{ color: themeVars.primary3 }"
    >
      <div class="flex flex-col gap-3 items-center justify-center max-w-[400px] text-center pb-[50px]">
        <CIcon icon="folder-open" size="36px" />
        <div class="font-size-[20px]">
          {{ t('canvasUI.browserApp.foldersFilesEmpty.emptyFolder') }}
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

import CIcon from '@lib/components/CIcon/CIcon.vue'
import useAppStore from '@browser/stores/app'
import useApiStore from '@browser/stores/api'
import useThemeVars from '@lib/composables/useThemeVars'

const { t } = useI18n()
const themeVars = useThemeVars()
const { appName } = useAppStore()
const { state: apiState } = useApiStore()

const hasSearchQuery = computed(() => !!apiState.searchQuery || Object.keys(apiState.searchMetadataFilters).length > 0)
</script>
